import {
  ChangeDetectionStrategy,
  Component,
  ViewChild,
  inject,
} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { SpuFormWrapperComponent } from '../../components/spu-form-wrapper/spu-form-wrapper.component';
import { CanComponentDeactivate } from '@app/core/auth/can-component-deactivate.interface';
import { 
  SpuFormConfig,
  SPU_HEADER_ACTIONS,
  SPU_PROPERTY_TABLE_SECTION,
  createSpuFormFields
} from '../../spu.config';

@Component({
  selector: 'app-ordinary-spu-add',
  standalone: true,
  imports: [SpuFormWrapperComponent],
  templateUrl: './ordinary-spu-add.component.html',
  styleUrls: ['./ordinary-spu-add.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrdinarySpuAddComponent implements CanComponentDeactivate {
  private translateService = inject(TranslateService);
  @ViewChild(SpuFormWrapperComponent)
  private spuFormWrapper?: SpuFormWrapperComponent;
  
  config: SpuFormConfig = {
    title: this.translateService.instant('goods.spu.form.titles.add_standard_product'),
    formFields: createSpuFormFields(false, this.translateService), // false = not package
    tableSections: [SPU_PROPERTY_TABLE_SECTION],
    headerActions: SPU_HEADER_ACTIONS,
    listRoute: '/goods/spu/ordinary',
    spuType: 'ordinary'
  };

  canDeactivate(
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    void currentRoute;
    void currentState;
    void nextState;

    return this.spuFormWrapper?.canDeactivate() ?? true;
  }
} 